export default __webpack_public_path__ + "static/media/ersatzteilliste.648711dd.pdf";